import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Header from "./Header";
import Footer from "./Footer";
import Landing from "./marketplace/Landing";
import RegisterBuyer from "./marketplace/RegisterBuyer";
import RegisterSupplier from "./marketplace/RegisterSupplier";
import HeaderSupplier from "./marketplace/supplier/Header";
import HeaderBuyer from "./marketplace/buyer/Header";
import RegisterByMarketing from "./vendor/RegisterByMarketing";
import HeaderVendor from "./vendor/Header";

const urlorigin =  window.location.origin;
const urlmp = urlorigin+'/marketplace';
const urlvendor = urlorigin+'/vendor';
const urlsupplier = urlmp+'/supplier';
const urlbuyer = urlmp+'/buyer';
const urlpath = window.location.protocol + '//' + window.location.host + '/' + window.location.pathname.split('/')[1];
const s_urlpath2 = window.location.pathname.split('/')[2];
const urlpath2 = urlpath + '/' + s_urlpath2;

ReactDOM.render(
    <React.StrictMode>
        {
            urlpath !== urlmp && urlpath !== urlvendor && (
                <>
                    <Header/>
                    <App style={{'margin-bottom': '53px'}}/>
                    <Footer/>
                </>
            )
        }
        {
            urlpath === urlmp && (
                <>
                    <link rel="stylesheet" href="/assets_admin/css/main.css?v=1.1"/>
                    {
                        (s_urlpath2 === undefined || s_urlpath2 === '') && (
                            <>
                                <Landing/>
                            </>
                        )
                    }
                    {
                        (s_urlpath2 !== undefined && s_urlpath2 !== '' && s_urlpath2 === 'supplier') && (
                            <HeaderSupplier/>
                        )
                    }
                    {
                        (s_urlpath2 !== undefined && s_urlpath2 !== '' && s_urlpath2 === 'buyer') && (
                            <HeaderBuyer/>
                        )
                    }
                    {
                        (s_urlpath2 !== undefined && s_urlpath2 !== '' && s_urlpath2 === 'register_supplier') && (
                            <RegisterSupplier/>
                        )
                    }
                    {
                        (s_urlpath2 !== undefined && s_urlpath2 !== '' && s_urlpath2 === 'register_buyer') && (
                            <RegisterBuyer/>
                        )
                    }
                </>
            )
        }
        {
            urlpath === urlvendor && (
                <>
                    <link rel="stylesheet" href="/assets_admin/css/main.css?v=1.1"/>
                    {
                        (s_urlpath2 === 'register_by_marketing') && (
                            <RegisterByMarketing/>
                        )
                    }
                    {
                        (s_urlpath2 !== 'register_by_marketing') && (
                            <HeaderVendor/>
                        )
                    }
                </>
            )
        }
    </React.StrictMode>,
    document.getElementById('root')
);
